import { useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, Paper } from '@mui/material'
import { WaterlineCalendarRow } from './types'
import { WaterlineTestResult } from '../../practice/waterline/types'

type WaterlineTestAlertsProps = {
  practices: WaterlineCalendarRow[] | null,
}

type TestAlert = {
  testDate: string,
  practiceName: string,
  customerNumber: string,
  testId: number,
}

const WaterlineTestAlerts = (props: WaterlineTestAlertsProps) => {
  const { practices } = props

  const [showAlerts, setShowAlerts] = useState(true)

  const navigate = useNavigate()

  const testAlerts = useMemo(() => {
    const testAlerts: TestAlert[] = practices?.flatMap((practice: WaterlineCalendarRow) => {
      return practice.testAlerts
        .map((result: WaterlineTestResult) => {
          const testDate = (new Date(result.test_date ?? '')).toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric'})

          const testAlert: TestAlert = {
            testDate: testDate,
            customerNumber: result.customer_number,
            practiceName: practice.practiceName,
            testId: result.test_result_id,
          }
          return testAlert
        })
    }) ?? []

    return testAlerts
  }, [practices])

  const closeHandler = () => {
    setShowAlerts(false)
  }

  return testAlerts?.length && showAlerts ? (
    <Paper className="waterline-alerts-wrapper" sx={{ backgroundColor: 'rgb(249, 188, 188)' }}>
      <div>
        <strong>You have { testAlerts?.length ?? 0 } recent failed retests</strong>
      </div>
      <br />
      {
        testAlerts.map((alert: TestAlert) => {
          const link = `/corp/practice/${alert.customerNumber}/waterline-management`
          return (
            <div key={alert.testId}>Test Date: {alert.testDate}{' '}
              <span className="waterline-link" onClick={() => navigate(link)}>
                Customer Name: {alert.practiceName}
              </span>
            </div>
          )
        })
      }
      <div className="flex flex-end">
        <Button onClick={closeHandler}>Close</Button>
      </div>
    </Paper>
  ) : null
}

export default WaterlineTestAlerts
